import { isFolloweeUser } from '../api/profile'

export const checkIsFollowingUser = async (userId: number) => {
    let promiseResult
    await isFolloweeUser({ id: userId })
        .then((res) => {
            promiseResult = res.result
        })
        .catch((e) => console.log(e))
    return await promiseResult
}
